'use client';
import dynamic from 'next/dynamic';
import { memo, Suspense } from 'react';

import { useEmailConfirmDrawerBannerShow } from '../../hooks/useEmailConfirmDrawerBannerShow';
const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.Content),
	{
		ssr: false,
	}
);

type Props = {
	withRemind?: boolean;
};

export const EmailConfirmDrawerBanner = memo<Props>(({ withRemind }) => {
	const isShow = useEmailConfirmDrawerBannerShow(!withRemind);

	if (!isShow) {
		return null;
	}

	return (
		<Suspense>
			<Content withRemind={withRemind} />
		</Suspense>
	);
});
EmailConfirmDrawerBanner.displayName = 'EmailConfirmDrawerBanner';
